module.exports = __webpack_public_path__ + "img/resume.377217f3.svg";